import LikeService from '../../../modules/like/likeService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'LIKE_FORM'

const likeFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: likeFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await LikeService.find(id)
      }

      dispatch({
        type: likeFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: likeFormActions.INIT_ERROR,
      })

      dispatch(push('/like'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: likeFormActions.CREATE_STARTED,
      })

      await LikeService.create(values)

      dispatch({
        type: likeFormActions.CREATE_SUCCESS,
      })

      Message.success(i18n('entities.like.create.success'))

      dispatch(push('/like'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: likeFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: likeFormActions.UPDATE_STARTED,
      })

      await LikeService.update(id, values)

      dispatch({
        type: likeFormActions.UPDATE_SUCCESS,
      })

      Message.success(i18n('entities.like.update.success'))

      dispatch(push('/like'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: likeFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default likeFormActions
